/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Color } from './';
import {
    ColorFromJSON,
    ColorFromJSONTyped,
    ColorToJSON,
} from './';

/**
 * 
 * @export
 * @interface FavoriteColorResponse
 */
export interface FavoriteColorResponse {
    /**
     * 
     * @type {Color}
     * @memberof FavoriteColorResponse
     */
    color: Color;
    /**
     * Whether a light or dark version of `color` is preferred
     * @type {boolean}
     * @memberof FavoriteColorResponse
     */
    light?: boolean;
}

/**
 * Check if a given object implements the FavoriteColorResponse interface.
 */
export function instanceOfFavoriteColorResponse(value: object): value is FavoriteColorResponse {
    if (!('color' in value) || value['color'] === undefined) return false;
    return true;
}

export function FavoriteColorResponseFromJSON(json: any): FavoriteColorResponse {
    return FavoriteColorResponseFromJSONTyped(json, false);
}

export function FavoriteColorResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteColorResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'color': ColorFromJSON(json['color']),
        'light': json['light'] == null ? undefined : json['light'],
    };
}

export function FavoriteColorResponseToJSON(value?: FavoriteColorResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'color': ColorToJSON(value['color']),
        'light': value['light'],
    };
}

